import { Image, Text, VStack } from "@chakra-ui/react";
import React from "react";

const FeatureCard = ({
  title,
  description,
  titleFontSize,
  image,
  altText,
  whoNeedsImage,
}: any) => {
  return (
    <VStack
      maxW="413px"
      // minH="187px"
      minH="340px"
      alignItems="flex-start"
      border="1px solid #CEE0DC"
      w="100%"
      gap={0}
      py={5}
      px={4}
    >
      <Image
        w={whoNeedsImage ? "48px" : "80px"}
        h={whoNeedsImage ? "48px" : "80px"}
        src={image}
        alt={altText}
      />

      <Text
        lineHeight="100%"
        fontSize={titleFontSize}
        className="light-text"
        mt={5}
        pt="10px"
        pb="14px"
        as="h3"
      >
        {title}
      </Text>
      <Text
        color="#6A7471"
        className="regular-text"
        fontSize="16px"
        dangerouslySetInnerHTML={{ __html: description }}
      ></Text>
    </VStack>
  );
};

export default FeatureCard;
